import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ESGDashboard from './ESGDashboard';
import CompanyVerification from './CompanyVerification';
import CompanyDetail from './CompanyDetail';
// import ESGFormNew from './ESGFormNew'; // DEPRECATED - Use /company-verification instead
import ESGSuccess from './ESGSuccess';
import ReportPage from './ReportPage';
import PublicCertificationPage from './PublicCertificationPage';
import AdminPanel from './components/admin/AdminPanel';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import { WagmiProvider } from 'wagmi';
import { wagmiConfig } from './App'; // Importa la configurazione corretta
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider} from '@tanstack/react-query';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import KYCCompleted from "./KYCCompleted";
import usePageTracking from "./usePageTracking";


const queryClient = new QueryClient();

function AnalyticsTracker() {
  usePageTracking();
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/kyc-completed" element={<KYCCompleted />} />
            <Route path="/esg-dashboard" element={<ESGDashboard />} />
            <Route path="/company-verification" element={<CompanyVerification />} />
            <Route path="/company/:id" element={<CompanyDetail />} />
            {/* DEPRECATED: /esg-form redirects to /company-verification */}
            <Route path="/esg-form" element={<Navigate to="/company-verification" replace />} />
            <Route path="/esg-success" element={<ESGSuccess />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/verify/:certificationId" element={<PublicCertificationPage />} />
            <Route path="/admin/*" element={<AdminPanel />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </Router>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
